import { apiClient } from '@/services/apiClient';

export type WaitlistEntryResponse = {
    already_registered: boolean;
};

export const waitlistEntryService = {
    joinWaitlist(email: string, comments?: string | null, contactAboutBeta?: boolean) {
        return apiClient.post<WaitlistEntryResponse>('/waitlist-entries', {
            email,
            comments,
            contact_about_beta: contactAboutBeta,
        });
    },
};
